import type PulseApi from '../api/PulseApi';
import type { AppConfig } from '../app/AppConfig';
import AccountStore from '../routes/account/store/AccountStore';
import BundleStore from '../routes/bundles/store/BundleStore';
import AuthStore from '../routes/login/store/AuthStore';
import ProductStore from '../routes/products/store/ProductStore';
import PromotionStore from '../routes/promotions/store/PromotionStore';
import PulseKeysStore from '../routes/pulse-keys/store/PulseKeysStore';
import SettingStore from '../routes/settings/store/SettingStore';
import BillingStore from '../routes/users/edit/billing/store/BillingStore';
import UserStore from '../routes/users/store/UserStore';

export default class RootStore {
  readonly accountStore: AccountStore;
  readonly authStore: AuthStore;
  readonly billingStore: BillingStore;
  readonly bundleStore: BundleStore;
  readonly productStore: ProductStore;
  readonly promotionStore: PromotionStore;
  readonly pulseKeyStore: PulseKeysStore;
  readonly settingStore: SettingStore;
  readonly userStore: UserStore;

  constructor(private readonly dependencies: RootStoreDependencies) {
    this.accountStore = new AccountStore(dependencies.api);
    this.authStore = new AuthStore(dependencies.api, this.accountStore);
    this.billingStore = new BillingStore(dependencies.api, this.authStore);
    this.productStore = new ProductStore(dependencies.api, this.authStore);
    this.settingStore = new SettingStore(dependencies.api);

    this.bundleStore = new BundleStore(
      dependencies.api,
      this.productStore,
      this.authStore,
    );

    this.promotionStore = new PromotionStore(
      dependencies.api,
      this.bundleStore,
      this.productStore,
    );

    this.pulseKeyStore = new PulseKeysStore(
      dependencies.api,
      this.authStore,
      this.accountStore,
      this.productStore,
      this.bundleStore,
    );

    this.userStore = new UserStore(dependencies.api);
  }

  get appConfig(): AppConfig {
    return this.dependencies.appConfig;
  }

  setBaseApiUrl(baseUrl?: string) {
    this.dependencies.api.setBaseUrl(baseUrl);
  }
}

export interface RootStoreDependencies {
  api: PulseApi;
  appConfig: AppConfig;
}
